import React from 'react';
import { sortBy, uniq, uniqBy } from 'lodash';
import { useSelector } from 'react-redux';

/**
 * Use Makes for Asset-type-ids Hook
 */
export default (assetTypeIds: Array<number>) => {
  const { typesList } = useSelector((state) => state);

  const next = React.useMemo(() => {
    if (assetTypeIds.length) {
      const { makes, makeTypes } = typesList;
      const makeIds = uniq(makeTypes.data
        .filter((item) => assetTypeIds.includes(item.typeId))
        .map((item) => item.makeId)
      );
      const next = makes.data.filter((item) => makeIds.includes(item.id));
      return sortBy(uniqBy(next, (item) => item.id), (item) => item.name);
    }
    return [];
  }, [assetTypeIds, typesList]);

  return next;
};
